import { Html, Image } from "@custom/schema";
import React from "react";
export function BlockImage(props) {
    var _props_image;
    return /*#__PURE__*/ React.createElement("figure", {
        className: "mt-16 mb-9 mx-auto"
    }, props.image ? /*#__PURE__*/ React.createElement(Image, {
        className: "aspect-video object-cover w-full",
        source: props.image.source,
        alt: (_props_image = props.image) === null || _props_image === void 0 ? void 0 : _props_image.alt
    }) : null, props.caption ? /*#__PURE__*/ React.createElement("figcaption", {
        className: "mt-4 flex gap-x-2 text-sm leading-6 text-gray-500"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.caption
    })) : null);
}
